import {HttpClient, HttpEventType} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { Platform } from '@ionic/angular';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

import {environment} from 'environment';
import {AuthRequest} from 'shared/auth-request/auth-request';
import { CModule } from '../model/model';

const HTTP_OK_CODE: number = 200;

@Injectable()
export class CModuleRepository {

  constructor(
    private http: HttpClient,
    private authRequest: AuthRequest,
    private platform: Platform,
    private nativeHttp: HTTP,
    private fileOpener: FileOpener,
    private file: File,
  ) { }

  public getCModules(type:string): Observable<Array<CModule>> {
    return this.authRequest.handleRequest(
      this.http.get<Array<CModule>>(environment.cmodule.cmoduleRoute + '?type='+ type, {withCredentials: true}));
  }

  public getCModule(cmoduleId: string): Observable<CModule> {
    return this.authRequest.handleRequest(
      this.http.get<CModule>(`${environment.cmodule.cmoduleRoute}/${cmoduleId}`, {withCredentials: true}));
  }

}
